import '@safeguardproperties/proto/lambda/ml/promptproject/v1/promptproject_v1_pb';
import '@safeguardproperties/proto/lambda/ml/prompt/v1/prompt_v1_pb';
import '@safeguardproperties/proto/lambda/ml/prompttemplate/v1/prompttemplate_v1_pb';
import {
  PromptProject,
  State,
} from '@safeguardproperties/proto/eventsource/ml/promptproject/v1/promptproject_v1_pb';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Container,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Switch,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { ProjectClient } from './ProjectClient';
import { useNavigate } from 'react-router-dom';

const domain = globalThis.location.host
  .split('.')
  .slice(1)
  .join('.')
  .split(':')[0];
const pc = new ProjectClient(
  `https://promptapi.${domain}/promptproject/v1/`,
  true
);

const devel = true;

const Projects = () => {
  const [projects, setProjects] = useState<PromptProject[] | null>(null);
  const [filteredProjects, setFilteredProjects] = useState<
    PromptProject[] | null
  >(null);

  useEffect(() => {
    const get = async () => {
      try {
        const response = await pc.List();
        /// TODO: either limit this, ask for a bulk call, or have list return data
        const _projects: PromptProject[] = [];
        for (const i in response.ids) {
          const p = await pc.GetProject(response.ids[i]);
          if (p.PromptProject) {
            _projects.push(p.PromptProject);
          }
        }
        setProjects(_projects);
        setFilteredProjects(_projects);
      } catch (error) {
        console.error('Failed to fetch projects:', error);
      }
    };
    get();
  }, []);

  const navigate = useNavigate();
  return (
    <Container>
      <h1>Prompt Library</h1>
      <Box display='flex' alignItems='center' mb={2}>
        <input
          type='text'
          placeholder='Search projects...'
          style={{ flex: 1, padding: '8px', fontSize: '1rem' }}
          onChange={(e) => {
            const value = e.target.value.toLowerCase();
            setFilteredProjects((prev) =>
              prev
                ? prev.filter(
                    (p) =>
                      p.description?.toLowerCase().includes(value) ||
                      p.id?.toLowerCase().includes(value)
                  )
                : null
            );
          }}
        />
        <Box ml={2}>
          <button
            style={{
              padding: '8px 16px',
              fontSize: '1rem',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            onClick={() => navigate('/prompts/project/')}
          >
            New Project
          </button>
        </Box>
      </Box>
      {filteredProjects && (
        <List dense sx={{ bgcolor: 'background.paper' }}>
          {filteredProjects.map((project) => (
            <ListItem key={project.id}>
              <ListItemButton
                onClick={() => navigate(`/prompts/project/${project.id}`)}
              >
                <ListItemText
                  primary={project.description}
                  secondary={`Created by ${project.createBy}`}
                />
                <Switch
                  edge='end'
                  checked={project.state === State.ACTIVE}
                  disabled={true}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Container>
  );
};

interface PartProps {
  uuid: string;
}

const PromptProjects = () => {
  return <Projects></Projects>;
};

export default PromptProjects;
